module.exports = __webpack_public_path__ + "img/ipage_2 1.ff21d17b.png";